import ProductVideos from './ProductVideos';

export default ProductVideos;


// WEBPACK FOOTER //
// ./src/scenes/Products/ProductDetail/ProductVideosTab/ProductVideos/index.ts